import React, { ReactNode } from 'react';
import './FileButton.scss';

export interface FileButtonProps extends React.PropsWithChildren<any> {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    accept?: string;
    disabled?: boolean;
    buttonClass?: string;
    block?: boolean;
}

export const FileButton: React.FC<FileButtonProps> = (props) => {
    const wrapTextWithSpan = (child: string | ReactNode) => {
        if (typeof child === 'string') return <span>{child}</span>;
        return child;
    }

    const accepts = props.accept || '.pdf,application/pdf,application/vnd.excel';

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e);
        //clear the file after omitting it
        // so you can choose the same one again
        e.target.value = '';
    }
    
    let buttonClass: string | undefined;
    let p: any;
    ({buttonClass, ...p} = props);

    let fileInput : HTMLInputElement | null = null;

    const classesForButton = [
        'btn',
        'btn-default',
        'btn-ts-file-upload',
        (props.block) ? "btn-block" : undefined,
        buttonClass
    ];

    return (
        <a className='cs-react'>
            <button 
                onClick={() => {if (fileInput !== null) {fileInput.click()}}}
                disabled={props.disabled}
                type="button"
                className={classesForButton.join(" ")}
            >
                {React.Children.map(props.children, wrapTextWithSpan)}
            </button>
            <input tabIndex={-1} type="file" ref={fi => fileInput = fi} name={props.name} className="hidden-input" onChange={onChange} accept={accepts} disabled={props.disabled} />
        </a>
    );
}

(FileButton as any).displayName = 'FileButton';